import { render, staticRenderFns } from "./eventHandle.vue?vue&type=template&id=62e4661a&scoped=true&"
import script from "./eventHandle.vue?vue&type=script&lang=js&"
export * from "./eventHandle.vue?vue&type=script&lang=js&"
import style0 from "./eventHandle.vue?vue&type=style&index=0&id=62e4661a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e4661a",
  null
  
)

export default component.exports